import { render, staticRenderFns } from "./LogoSettings.vue?vue&type=template&id=def76e46"
import script from "./LogoSettings.vue?vue&type=script&lang=ts"
export * from "./LogoSettings.vue?vue&type=script&lang=ts"
import style0 from "./LogoSettings.vue?vue&type=style&index=0&id=def76e46&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('def76e46')) {
      api.createRecord('def76e46', component.options)
    } else {
      api.reload('def76e46', component.options)
    }
    module.hot.accept("./LogoSettings.vue?vue&type=template&id=def76e46", function () {
      api.rerender('def76e46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout-editor/LogoSettings.vue"
export default component.exports